// A link a first-party page asks its host to open in a proxied tab ("revault-open-url",
// DESIGN.md 16.5). Study Hall never opens links itself: a click hands the literal URL to the
// Re:Vault shell (or Re:Vault OS), which opens it through the proxy. Only http(s), at most 2048
// characters and no control characters or whitespace get through. Returns the normalized href or
// null. Tiny and dependency-free: the shell's main bundle imports it too.
export const OPEN_URL_MAX = 2048;

export function hasControl(s) {
	for (let i = 0; i < s.length; i++) { const c = s.charCodeAt(i); if (c < 32 || c === 127) return true; }
	return false;
}

export function openableUrl(raw) {
	if (typeof raw !== "string" || !raw || raw.length > OPEN_URL_MAX || hasControl(raw) || /\s/.test(raw)) return null;
	let u;
	try { u = new URL(raw); } catch (e) { void e; return null; }
	if ((u.protocol !== "http:" && u.protocol !== "https:") || !u.hostname) return null;
	return u.href.length > OPEN_URL_MAX ? null : u.href;
}
